//IMPORTS LIBS...
import React, {
  useEffect,
  useState,
  useMemo,
  useCallback,
  useRef,
} from "react";
import _, { throttle, debounce } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import axios from "axios";
import MicroModal from "micromodal";
import { differenceInSeconds, parse, addSeconds, subSeconds } from "date-fns";
import { ArrowDown2 } from "iconsax-reactjs";

//ACTIONS...
import { Tooltippy, PopoverDashboard } from "../../../actions/Tippy";
import {
  addChat,
  addChatSimult,
  typingadd,
  AlterScreen,
  ShowInfoDisplay,
  clearConferenceExt,
  CallConsultaInterna,
  addMonitoring,
  addMonitoringSimult,
  EditTypeMonitorings,
  EditTypeMonitoringm,
} from "../../../actions";
import { InitialMonitoring, SharedScreen } from "../../../actions/websocket";
import testJson from "../../../actions/testJson";

//COMPONENTS...
import TextMedium from "../TextComponent/TextMedium";
import TimeCounterInternal from "../../../containers/TimeCounterInternalDash";
import PopoverColumnsFilter from "../../popovercolumnsfilter/PopoverColumnsFilter";
import Table from "../../table";
import TableVirtual from "../../TableVirtual";
import BlockUnBlockUserModal from "../../modals/BlockUnBlockUserModal";
import SeeAtends from "../../modals/ModalSeeAtends";
import TransferClientModal from "../../../containers/TransferClientModal";
import TransferClient from "../../../containers/TransferClient";
import InputSearch from "../../InputSearch/InputSearch";
import MonitoringDashboard from "../../modals/ModalMonitoringDash";
import Loading from "../../Loading";
import Typography from "../../Typography";
import MonitoringDashboardV2 from "../../modals/ModalMonitoringDashV2/ModalMonitoringDashV2";

//HOOKS...
import { useThrottledSelector } from "./hooks/useThrottledSelector";
import { useRAFDebounce, useRAFThrottle } from "./hooks/useRAFDebounce";

//ASSETS...
import { ReactComponent as ColumnFilterIcon } from "../../../build/images/icons/ColumnFilterIcon.svg";
import { ReactComponent as MessengerIcon } from "../../../build/images/icons-channels/messenger.svg";
import { ReactComponent as WhatsappIcon } from "../../../build/images/icons-channels/whatsapp-large.svg";
import { ReactComponent as WhatsappVoiceIcon } from "../../../build/images/whatsapp_voice.svg";
import { ReactComponent as FacebookIcon } from "../../../build/images/icons-channels/facebook.svg";
import { ReactComponent as VozIcon } from "../../../build/images/icons-channels/voz-large.svg";
import { ReactComponent as EmailIcon } from "../../../build/images/icons-channels/email.svg";
import { ReactComponent as WebchatIcon } from "../../../build/images/icons-channels/webchat-large.svg";
import { ReactComponent as TelegramIcon } from "../../../build/images/icons-channels/telegram-large.svg";
import { ReactComponent as GOOGLEGBM } from "../../../build/images/icons-channels/googlegbm-large.svg";
import { ReactComponent as InstaIcon } from "../../../build/images/icons-channels/instagram-large.svg";
import { ReactComponent as ClockIcon } from "../../../build/images/viewactionclock.svg";
import { ReactComponent as MessageIcon } from "../../../build/images/viewactionmessage.svg";
import { ReactComponent as CallIcon } from "../../../build/images/viewactioncall.svg";
import { ReactComponent as SussurroIcon } from "../../../build/images/viewactionprofile.svg";
import { ReactComponent as EyeIcon } from "../../../build/images/viewactioneye.svg";
import { ReactComponent as MonitorIcon } from "../../../build/images/viewactionescuta.svg";
import { ReactComponent as PointMessageIcon } from "../../../build/images/viewactionmessagepoint.svg";
import { ReactComponent as BlockIcon } from "../../../build/images/viewactionblock.svg";
import { ReactComponent as ListeningIcon } from "../../../build/images/viewactionescuta.svg";
import { ReactComponent as TEAMS } from "../../../build/images/channelsNew/teamsBig.svg";
import { ReactComponent as EmptyState } from "../../../build/images/emptystatemanagerhorizontal.svg";
import LoadingTable from "../../../build/images/Column.png";

//SERVICES
import { connection_platform } from "../../../services/api";

// let columns = [];
// let exhibColumn = [];
let TimeFormat = require("hh-mm-ss");
// let colaboratorsDataFiltered = [];
// let colaboratorsData = [];
let codeStatus = [];
var port = localStorage.getItem("port");
var pathname = localStorage.getItem("pathname");

function defaultSorting(rowA, rowB, columnId) {
  const objectRowA = rowA.original[columnId].data.toLowerCase();
  const objectRowB = rowB.original[columnId].data.toLowerCase();

  if (objectRowA > objectRowB) return -1;
  if (objectRowB > objectRowA) return 1;

  return 0;
}

function numberSorting(rowA, rowB, columnId) {
  const objectRowA = rowA.original[columnId].data;
  const objectRowB = rowB.original[columnId].data;

  if (objectRowA > objectRowB) return -1;
  if (objectRowB > objectRowA) return 1;

  return 0;
}

function customSorting(rowA, rowB, columnId) {
  const customRowA = rowA.original[columnId].config.customOrder;
  const customRowB = rowB.original[columnId].config.customOrder;

  if (customRowA > customRowB) return -1;
  if (customRowB > customRowA) return 1;
  return 0;
}

function dateSorting(rowA, rowB, columnId) {
  const dateRowA = rowA.original[columnId].config.customOrder.getTime();
  const dateRowB = rowB.original[columnId].config.customOrder.getTime();

  if (dateRowA > dateRowB) return -1;
  if (dateRowB > dateRowA) return 1;
  return 0;
}

function dateTimeSorting(rowA, rowB, columnId) {
  const dateRowA = rowA.original[columnId].config.customOrder;
  const dateRowB = rowB.original[columnId].config.customOrder;

  if (dateRowA > dateRowB) return -1;
  if (dateRowB > dateRowA) return 1;
  return 0;
}

const CardTableOperatorsManager = ({ title }) => {
  const exhibColumn = useSelector((state) => state.columnsalloperators);
  const usersReduce = useSelector((state) => state.agents);
  const managerStatusOperators = useSelector(
    (state) => state.datamanagerstatusoperators,
  );
  const [usersRefactored, setUsersRefactored] = useState([]);
  const LoginCompleteReducer = useSelector((state) => state.ipcurrent);
  const FiltersManager = useSelector((state) => state.filtersmanager);
  const ChatSimult = useSelector((state) => state.chatsimult);
  const InfoUsers = useSelector((state) => state.informationusers);
  const MonitoringSimult = useSelector((state) => state.monitoringsimult);
  const GroupsPermissionSupervisor = useSelector(
    (state) => state.grouppermissionsupervisor,
  );

  const [horaaction, setHoraAction] = useState("");
  const [duration, setDuration] = useState("");
  const [reasonaction, setReasonAction] = useState("");
  const [userout, setUserOut] = useState("");
  const [inable, setInable] = useState(false);
  const [act, setAct] = useState("1");
  const [idsup, setIdSup] = useState("");
  const [idblock, setIdBlock] = useState("");
  const [actdesb, setActDesb] = useState("1001");
  const [infosGeral, setInfosGeral] = useState({
    title: "",
    agente: "Ingenium",
    ramal: 9999,
    grupo: "Diretoria",
    jsoncall: "",
  });
  const [infoTransfer, setInfoTransfer] = useState(false);
  const [dashboardMonitor, setDashboardMonitor] = useState(false);
  const [makeSearch, setMakeSearch] = useState(false);
  const [searchData, setSearchData] = useState("");
  // const [dataTotal, setDataTotal] = useState([]);
  const [monitoringInfo, setMonitoringInfo] = useState("");
  const [monitoringInfoJson, setMonitoringInfoJson] = useState("");
  const [monitoringSim, setMonitoringSim] = useState([]);
  // const [users, setUsers] = useState([]);
  const [colaboratorsDataFiltered, setColaboratorsDataFiltered] = useState([]);
  const [filterTableStatus, setFilterTableStatus] = useState(["LV"]);
  const [groupsPermissionState, setGroupsPermissionState] = useState([]);
  // const [rawUsers, setRawUsers] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);
  const [openCard, setOpenCard] = useState(
    localStorage.getItem("managerOperatorsOpenCard")
      ? localStorage.getItem("managerOperatorsOpenCard") === "true"
      : true,
  );
  const [shouldRender, setShouldRender] = useState(openCard);

  const dispatch = useDispatch();

  const usersRef = useRef([]);
  // const groupsPermissionRef = useRef([]);
  // const processUsersRef = useRef(null);
  const monitoringSimultRef = useRef(monitoringSim);
  const monitoringInfoRef = useRef(monitoringInfo);
  const rawUsersRef = useRef(usersReduce);
  const filtersRef = useRef({
    FiltersManager,
    managerStatusOperators,
    MonitoringSimult,
    groupsPermissionState,
  });
  const processedDataRef = useRef(new Map());
  const lastProcessTimeRef = useRef(0);
  const prevSearchDataRef = useRef(searchData);

  // const debouncedProcess = useRAFDebounce((users, filters) => {
  //   processUsersOptimized(users, filters);
  // }, connection_platform.delayTableOperators);

  // const throttledUsers = useThrottledSelector(usersReduce, 3000);

  // const throttledProcess = useRAFThrottle((...args) => {
  //   processUsersOptimized(...args);
  // }, 5000);

  // const throttledProcess = useMemo(
  //   () =>
  //     throttle(
  //       (users, filters, statusOps, monit, groups) => {
  //         processUsersOptimized(users, filters, statusOps, monit, groups);
  //       },
  //       1000, // 1 segundo é suficiente. 5s é muito tempo de lag para o usuário.
  //       { leading: true, trailing: true } // Garante que atualiza no começo e no fim
  //     ),
  //   [processUsersOptimized]
  // );

  const ComponentCache = {
    cache: new Map(),

    getKey: (type, id, ...deps) => {
      return `${type}-${id}-${deps.join("-")}`;
    },

    get: function (key) {
      return this.cache.get(key);
    },

    set: function (key, component) {
      this.cache.set(key, component);
      // Limita o tamanho do cache
      if (this.cache.size > 1000) {
        const firstKey = this.cache.keys().next().value;
        this.cache.delete(firstKey);
      }
    },

    clear: function () {
      this.cache.clear();
    },
  };

  // function chooseDisplay(nameDisplay) {
  //   const indexFind = exhibColumn.findIndex(
  //     (column) => column.title.toLowerCase() === nameDisplay.toLowerCase()
  //   );

  //   return exhibColumn[indexFind].exhib;
  // }

  const chooseDisplay = useCallback(
    (nameDisplay) => {
      const indexFind = exhibColumn.findIndex(
        (column) => column.title.toLowerCase() === nameDisplay.toLowerCase(),
      );

      // Adiciona uma verificação para evitar erros se a coluna não for encontrada
      if (indexFind > -1) {
        return exhibColumn[indexFind].exhib;
      }
      return true; // ou false, dependendo do seu padrão
    },
    [exhibColumn],
  );

  const InitialChat = (user) => {
    reduxChatInitial(
      parseInt(user.iduser),
      user.label,
      true,
      false,
      user.ramal,
    );
  };

  const reduxChatInitial = (iduser, displayname, active, opencall, ramal) => {
    let datatime = moment().format("YYYY/MM/DD HH:mm:ss");
    dispatch(
      addChatSimult(iduser, displayname, active, opencall, ramal, datatime),
    );
    dispatch(addChat(iduser, displayname, active, opencall, ramal, datatime));
    dispatch(typingadd(iduser, displayname));
    document.getElementById("simulation_click").click();
    // dispatch(AlterScreen('Atendentes'))
    // dispatch(ShowInfoDisplay('Atendentes'))
  };

  const InitialCall = (chatsimult, user) => {
    let erro = 0;

    if (chatsimult.length != 0) {
      chatsimult.map((chat) => {
        if (
          parseInt(chat.iduserout) === parseInt(user.iduser) &&
          chat.voz === false
        ) {
          erro = 1;
        } else if (
          parseInt(chat.iduserout) === parseInt(user.iduser) &&
          chat.voz === true
        ) {
          erro = 2;
        } else if (erro != 1 || erro != 2) {
          erro = 0;
        }
      });
      if (erro === 1) {
        reduxCallInitial(
          parseInt(user.iduser),
          user.label,
          user.ramal,
          user,
          true,
        );
      } else if (erro === 2) {
        console.log("JA POSSUI CHAT ATIVO COM VOZ");
      } else {
        reduxCallInitial(
          parseInt(user.iduser),
          user.label,
          user.ramal,
          user,
          false,
        );
      }
    } else {
      reduxCallInitial(
        parseInt(user.iduser),
        user.label,
        user.ramal,
        user,
        false,
      );
    }
  };

  const reduxCallInitial = (iduser, label, ramal, user, isConference) => {
    if (isConference) {
      dispatch(clearConferenceExt());
      dispatch(CallConsultaInterna(ramal, iduser, user));
      // dispatch(AlterScreen('Atendentes'))
      // dispatch(ShowInfoDisplay('Atendentes'))
    } else {
      reduxChatInitial(iduser, label, true, false, ramal);
      dispatch(CallConsultaInterna(ramal, iduser, user));
    }
    document.getElementById("simulation_click").click();
  };

  // const InitialMonitoringAction = (
  //   userin,
  //   userout,
  //   name,
  //   monitoringsimult,
  //   line,
  //   ramal,
  //   jsoncall
  // ) => {
  //   let erro = 0;
  //   let auxline;
  //   // console.log("VEIO AQ1.3", monitoringsimult);
  //   // console.log("VEIO AQ1.4", monitoringSim);
  //   // console.log("VEIO AQ1.5", monitoringInfo);
  //   if (monitoringSimultRef.current.length !== 0) {
  //     // console.log("VEIO AQ1.6", userout, line);
  //     monitoringSimultRef.current.map((monitoring) => {
  //       if (parseInt(monitoring.userout) === parseInt(userout)) {
  //         erro = 1;
  //         auxline = monitoring.line;
  //       } else if (erro != 1) {
  //         erro = 0;
  //       }
  //     });
  //     if (erro === 1) {
  //       if (parseInt(auxline) !== parseInt(line)) {
  //         editTypeMonitoring(userout, line, name, ramal, jsoncall);
  //       } else if (parseInt(auxline) === parseInt(line) && !monitoringInfo) {
  //         reduxMonitoringInitial(userin, userout, name, line, ramal, jsoncall);
  //       } else {
  //         reduxMonitoringInitial(userin, userout, name, line, ramal, jsoncall);
  //       }
  //     } else {
  //       reduxMonitoringInitial(userin, userout, name, line, ramal, jsoncall);
  //     }
  //   } else {
  //     reduxMonitoringInitial(userin, userout, name, line, ramal, jsoncall);
  //   }

  //   // dispatch(ShowInfoDisplay("Monitorias"));
  //   // dispatch(AlterScreen("Monitorias"));
  // };

  // FUNÇÃO ANTERIOR
  // const InitialMonitoringAction = (
  //   userin,
  //   userout,
  //   name,
  //   monitoringsimult,
  //   line,
  //   ramal,
  //   jsoncall
  // ) => {
  //   let erro = 0;
  //   let auxline;
  //   // console.log("VEIO AQ1.3", monitoringsimult);
  //   // console.log("VEIO AQ1.4", monitoringSim);
  //   // console.log("VEIO AQ1.5", monitoringInfo);
  //   if (monitoringSim.length !== 0) {
  //     // console.log("VEIO AQ1.6", userout, line);
  //     monitoringSim.map((monitoring) => {
  //       if (parseInt(monitoring.userout) === parseInt(userout)) {
  //         erro = 1;
  //         auxline = monitoring.line;
  //       } else if (erro != 1) {
  //         erro = 0;
  //       }
  //     });
  //     if (erro === 1) {
  //       if (parseInt(auxline) !== parseInt(line)) {
  //         editTypeMonitoring(userout, line, name, ramal, jsoncall);
  //       } else if (parseInt(auxline) === parseInt(line) && !monitoringInfo) {
  //         reduxMonitoringInitial(userin, userout, name, line, ramal, jsoncall);
  //       }
  //     } else {
  //       reduxMonitoringInitial(userin, userout, name, line, ramal, jsoncall);
  //     }
  //   } else {
  //     reduxMonitoringInitial(userin, userout, name, line, ramal, jsoncall);
  //   }

  //   // dispatch(ShowInfoDisplay("Monitorias"));
  //   // dispatch(AlterScreen("Monitorias"));
  // };

  const InitialMonitoringAction = (
    userin,
    userout,
    name,
    monitoringsimult,
    line,
    ramal,
    jsoncall,
  ) => {
    let erro = 0;
    let auxline;
    // console.log("VEIO AQ1.3", monitoringsimult);
    // console.log("VEIO AQ1.4", monitoringSim);
    // console.log("VEIO AQ1.5", monitoringInfo);
    if (monitoringSimultRef.current.length !== 0) {
      // console.log("VEIO AQ1.6", userout, line);
      monitoringSimultRef.current.map((monitoring) => {
        if (parseInt(monitoring.userout) === parseInt(userout)) {
          erro = 1;
          auxline = monitoring.line;
        } else if (erro != 1) {
          erro = 0;
        }
      });
      if (erro === 1) {
        if (parseInt(auxline) !== parseInt(line)) {
          editTypeMonitoring(userout, line, name, ramal, jsoncall);
        } else if (
          parseInt(auxline) === parseInt(line) &&
          !monitoringInfoRef.current
        ) {
          reduxMonitoringInitial(userin, userout, name, line, ramal, jsoncall);
        }
      } else {
        reduxMonitoringInitial(userin, userout, name, line, ramal, jsoncall);
      }
    } else {
      reduxMonitoringInitial(userin, userout, name, line, ramal, jsoncall);
    }

    // dispatch(ShowInfoDisplay("Monitorias"));
    // dispatch(AlterScreen("Monitorias"));
  };

  const reduxMonitoringInitial = (
    userin,
    userout,
    name,
    line,
    ramal,
    jsoncall,
  ) => {
    // dispatch(ShowInfoDisplay("Monitorias"));
    // dispatch(AlterScreen("Monitorias"));
    setMonitoringInfo({
      iduser: userout,
      label: name,
      ramal: ramal,
      jsoncall: jsoncall,
      monitoringLine: line,
    });
    setMonitoringInfoJson(jsoncall);
    // MicroModal.show("modal__monitoring-dashboard");
    dispatch(addMonitoring(userout, name, line, ramal));
    dispatch(addMonitoringSimult(userout, name, line, ramal));
    if (line != "4") {
      const socket = InitialMonitoring(userin, userout, line, ramal);
    } else {
      const socket = SharedScreen(ramal);
    }
  };

  const editTypeMonitoring = (userout, line, name, ramal, jsoncall) => {
    dispatch(EditTypeMonitorings(userout, line));
    dispatch(EditTypeMonitoringm(userout, line));
    // dispatch(ShowInfoDisplay("Monitorias"));
    // dispatch(AlterScreen("Monitorias"));
    setMonitoringInfo({
      iduser: userout,
      label: name,
      ramal: ramal,
      jsoncall: jsoncall,
      monitoringLine: line,
    });
    setMonitoringInfoJson(jsoncall);
  };

  const showModal = (userout, action, reasonaction, duration, status) => {
    if (action === "BQSUPER") {
      MicroModal.show("modal__desbloqueio");
      duration = duration.split(" ");
      let horaaction = duration[1].split("-");
      horaaction = horaaction[0];
      duration = duration[0];
      setReasonAction(reasonaction);
      setDuration(duration);
      setHoraAction(horaaction);
      setAct("1001");
      setActDesb("1001");
      setInable(false);
    } else {
      if (status !== null) {
        MicroModal.show("modal__bloqueio");
        setUserOut(userout);
        setAct("1");
        setInable(false);
      } else {
        axios
          .get(
            `${connection_platform.type_connect}://${pathname}:${port}/conn/checkuserblock?iduser=${userout}`,
          )
          .then((response) => {
            if (response.data.durationblock === 0) {
              var idreturnblockdescription = response.data.id;
              axios
                .get(
                  `${connection_platform.type_connect}://${pathname}:${port}/conn/checkuserblocksup?iduser=${userout}`,
                )
                .then((response) => {
                  MicroModal.show("modal__desbloqueio");
                  setInable(true);
                  duration = response.data.blockingdate.split("T");
                  let horaaction = duration[1].split("-");
                  horaaction = horaaction[0];
                  duration = duration[0];
                  duration = moment(duration, "YYYY-MM-DD").format(
                    "DD/MM/YYYY",
                  );
                  setUserOut(userout);
                  setHoraAction(horaaction);
                  setDuration(duration);
                  setReasonAction(response.data.blockingreason);
                  setIdBlock(idreturnblockdescription);
                  setIdSup(response.data.id);
                })
                .catch((error) => {
                  console.log("trycatch");
                });
            } else {
              setUserOut(userout);
              setAct(act);
              setInable(true);
              MicroModal.show("modal__bloqueio");
            }
          })
          .catch((error) => {
            console.log("trycatch");
          });
      }
    }
  };

  // const renderPopover = (e, name) => (
  //   <span className="action-label">{name}</span>
  // );

  const renderHandleActions = (user) => (
    <div className="popover__action-dashboard-screen">
      {/* <div
        className="popover__dashboard-screen__labels second"
        onClick={() => {
          setMonitoringInfo(user);
        }}
      >
        <li>
          <MessageIcon />
        </li>
        <li>
          <span>Monitorar</span>
        </li>
      </div> */}
      <div
        className="popover__dashboard-screen__labels second"
        onClick={() => InitialChat(user)}
      >
        <li>
          <MessageIcon />
        </li>
        <li>
          <span>Iniciar conversa</span>
        </li>
      </div>
      <div
        className="popover__dashboard-screen__labels second"
        onClick={() => InitialCall(ChatSimult, user)}
      >
        <li>
          <CallIcon />
        </li>
        <li>
          <span>Falar com atendente</span>
        </li>
      </div>
      <div
        className="popover__dashboard-screen__labels second"
        onClick={() => {
          InitialMonitoringAction(
            InfoUsers.id,
            user.iduser,
            user.label,
            MonitoringSimult,
            "1",
            user.ramal,
            user.jsoncall,
          );
        }}
      >
        <li>
          <ListeningIcon />
        </li>
        <li>
          <span>Escuta sigilosa</span>
        </li>
      </div>
      <div
        className="popover__dashboard-screen__labels second"
        onClick={() => {
          InitialMonitoringAction(
            InfoUsers.id,
            user.iduser,
            user.label,
            MonitoringSimult,
            "2",
            user.ramal,
            user.jsoncall,
          );
        }}
      >
        <li>
          <SussurroIcon />
        </li>
        <li>
          <span>Sussuro</span>
        </li>
      </div>
      <div
        className="popover__dashboard-screen__labels second"
        onClick={() => {
          InitialMonitoringAction(
            InfoUsers.id,
            user.iduser,
            user.label,
            MonitoringSimult,
            "3",
            user.ramal,
            user.jsoncall,
          );
        }}
      >
        <li>
          <PointMessageIcon />
        </li>
        <li>
          <span>Intercalar</span>
        </li>
      </div>
      <div
        className="popover__dashboard-screen__labels second"
        onClick={() =>
          showModal(
            user.iduser,
            user.status_sip,
            user.razao_bloqueio,
            user.duration,
            user.status,
          )
        }
      >
        <li>
          <BlockIcon />
        </li>
        <li>
          <span>Bloquear</span>
        </li>
      </div>
    </div>
  );

  function getMediaId(user) {
    let findMidia = "";
    if (
      (user.mediaid === "null" || user.mediaid === null) &&
      user.jsoncall &&
      (user.speaknum || user.razao_bloqueio)
    ) {
      let jsonSplit = user.jsoncall.split("¿");
      let jsonMediaid = jsonSplit.filter((split) =>
        split.includes(user.speaknum || user.razao_bloqueio),
      );
      let getMidia =
        jsonMediaid.length > 0 ? jsonMediaid[0].split("§")[0] : null;
      findMidia = getMidia;
    }

    let midiaId =
      user.mediaid && user.mediaid !== "null" ? user.mediaid : findMidia;

    return midiaId;
  }

  const renderStatus = (
    status,
    status_sip,
    razao_bloqueio,
    descfuturepause,
    directionChnd,
  ) => {
    if (status === "LV" && status_sip === "LV") {
      return (
        <div className="manager-box-status idle">
          <div className="manager-box-status__circle green"></div>
          <span>Livre</span>
        </div>
      );
    } else if (status === "AT" && status_sip === "AT") {
      return (
        <div className="manager-box-status answer">
          <div className="manager-box-status__circle blue"></div>
          <span>Atendimento</span>
        </div>
      );
    } else if (status === null && status_sip === null) {
      return (
        <div className="manager-box-status offline">
          <div className="manager-box-status__circle gray"></div>
          <span>Inativo</span>
        </div>
      );
    } else if (status === "null" && status_sip === "null") {
      return (
        <div className="manager-box-status offline">
          <div className="manager-box-status__circle gray"></div>
          <span>Inativo</span>
        </div>
      );
    } else if (status === null && status_sip === "LV") {
      return (
        <div className="manager-box-status idle">
          <div className="manager-box-status__circle green"></div>
          <span>Livre</span>
        </div>
      );
    } else if (status === "LV" && status_sip === "BQ") {
      return (
        <div className="manager-box-status block">
          <div className="manager-box-status__circle blue"></div>
          <span>Pausado</span>
        </div>
      );
    } else if (status === "BQ" && status_sip === "BQ") {
      return (
        <Tooltippy content={razao_bloqueio ? razao_bloqueio : ""}>
          <div className="manager-box-status block-reason">
            <div
              className="manager-box-status__circle red"
              style={{
                marginLeft:
                  razao_bloqueio && razao_bloqueio.length >= 84 ? "4px" : "0px",
              }}
            ></div>
            <span className="manager-box-status__text">
              {razao_bloqueio ? razao_bloqueio : ""}
            </span>
          </div>
        </Tooltippy>
      );
    } else if (status === null && status_sip === "BQ") {
      return (
        <Tooltippy content={razao_bloqueio ? razao_bloqueio : ""}>
          <div className="manager-box-status block-reason">
            <div
              className="manager-box-status__circle red"
              style={{
                marginLeft:
                  razao_bloqueio && razao_bloqueio.length >= 84 ? "4px" : "0px",
              }}
            ></div>
            <span className="manager-box-status__text">
              {razao_bloqueio ? razao_bloqueio : ""}
            </span>
          </div>
        </Tooltippy>
      );
    } else if (status_sip === "LV" && status === "AT") {
      return (
        <div className="manager-box-status answer">
          <div className="manager-box-status__circle blue"></div>
          <span>Atendimento</span>
        </div>
      );
    } else if (status_sip === "AT" && status === null) {
      return (
        <div className="manager-box-status answer">
          <div className="manager-box-status__circle blue"></div>
          <span>Atendimento</span>
        </div>
      );
    } else if (status_sip === "CHND" && razao_bloqueio !== "CHND") {
      return (
        <div
          className={`manager-box-status answer ${directionChnd === "1" ? "receptivo" : "ativo"}`}
        >
          <div
            className={`manager-box-status__circle ${directionChnd === "1" ? "pink" : "blue"}`}
          ></div>
          <span>
            Chamando {directionChnd === "1" ? "- Receptivo" : "- Ativo"}
          </span>
        </div>
      );
    } else if (status_sip === "CHND" && status != "CHND") {
      return (
        <div className="manager-box-status answer">
          <div className="manager-box-status__circle blue"></div>
          <span>Atendimento</span>
        </div>
      );
    } else if (status === "CHND" && status_sip != "LV") {
      return (
        <div className="manager-box-status answer">
          <div className="manager-box-status__circle blue"></div>
          <span>Atendimento</span>
        </div>
      );
    } else if (status === "ACW" && status_sip === "ACW") {
      return (
        <div className="manager-box-status answer">
          <div className="manager-box-status__circle yellow"></div>
          <span>AfterCallWork</span>
        </div>
      );
    } else if (status_sip === "RV" && status === "ATOS") {
      return (
        <div className="manager-box-status answer">
          <div className="manager-box-status__circle blue"></div>
          <span>Atendimento</span>
        </div>
      );
    } else if (status_sip === "BQSUPER" && status === "BQSUPER") {
      return (
        <div className="manager-box-status answer">
          <div className="manager-box-status__circle red"></div>
          <span>Bloqueado</span>
        </div>
      );
    } else if (status === "RV" && status_sip === "LV") {
      return (
        <div className="manager-box-status answer">
          <div className="manager-box-status__circle blue"></div>
          <span>Atendimento</span>
        </div>
      );
    }

    return "";
  };

  const renderStatusMemoized = useCallback(renderStatus, []);

  const renderStatusValue = (
    status,
    status_sip,
    razao_bloqueio,
    descfuturepause,
    directionChnd,
  ) => {
    if (
      (status === "LV" && status_sip === "LV") ||
      (status === null && status_sip === "LV")
    ) {
      return "Livre";
    } else if (
      (status === "AT" && status_sip === "AT") ||
      (status_sip === "LV" && status === "AT") ||
      (status_sip === "AT" && status === null) ||
      (status_sip === "CHND" && status != "CHND") ||
      (status === "CHND" && status_sip != "LV") ||
      (status_sip === "RV" && status === "ATOS") ||
      (status === "RV" && status_sip === "LV")
    ) {
      return "Atendimento";
    } else if (
      (status === null && status_sip === null) ||
      (status === "null" && status_sip === "null")
    ) {
      return "Inativo";
    } else if (status === "LV" && status_sip === "BQ") {
      return "Pausado";
    } else if (
      (status === "BQ" && status_sip === "BQ") ||
      (status === null && status_sip === "BQ")
    ) {
      return { razao_bloqueio };
    } else if (status === "ACW" && status_sip === "ACW") {
      return "AfterCallWork";
    } else if (status_sip === "BQSUPER" && status === "BQSUPER") {
      return "Bloqueado";
    } else if (status_sip === "CHND" && razao_bloqueio !== "CHND") {
      return `Chamando ${directionChnd === "1" ? "- Receptivo" : "- Ativo"}`;
    }
    return "";
  };

  const renderQtdCalls = (status, status_sip, todos, user) => {
    let temp = [];
    let qtdWhatsapp = 0;
    let qtdFacebook = 0;
    let qtdEmail = 0;
    let qtdWebchat = 0;
    let qtdVoz = 0;
    let qtdTelegram = 0;
    let qtdInstagram = 0;
    let qtdGoogleGBM = 0;
    let qtdTeams = 0;
    let qtdWhatsappVoice = 0;
    let arrayMount = [];

    try {
      let aux = todos.split("¿");
      aux.map((todo) => {
        arrayMount.push({
          CHANNEL: todo.split("§")[0],
          PHONE: todo.split("§")[1],
        });
      });

      arrayMount.map((todo) => {
        if (parseInt(todo.CHANNEL) === 5) qtdWhatsapp = qtdWhatsapp + 1;

        if (parseInt(todo.CHANNEL) === 4) qtdFacebook = qtdFacebook + 1;

        if (parseInt(todo.CHANNEL) === 3) qtdEmail = qtdEmail + 1;

        if (parseInt(todo.CHANNEL) === 2) qtdWebchat = qtdWebchat + 1;

        if (parseInt(todo.CHANNEL) === 1) qtdVoz = qtdVoz + 1;

        if (parseInt(todo.CHANNEL) === 8) qtdTelegram = qtdTelegram + 1;

        if (parseInt(todo.CHANNEL) === 6) qtdInstagram = qtdInstagram + 1;

        if (parseInt(todo.CHANNEL) === 11) qtdGoogleGBM = qtdGoogleGBM + 1;

        if (parseInt(todo.CHANNEL) === 15) qtdTeams = qtdTeams + 1;

        if (parseInt(todo.CHANNEL) === 16)
          qtdWhatsappVoice = qtdWhatsappVoice + 1;
      });
    } catch (error) {
      console.log("Continue");
    }
    if (qtdTelegram > 0) {
      temp.push({
        channel: 8,
        qtd: qtdTelegram,
      });
    }

    if (qtdInstagram > 0) {
      temp.push({
        channel: 6,
        qtd: qtdInstagram,
      });
    }

    if (qtdWhatsapp > 0) {
      temp.push({
        channel: 5,
        qtd: qtdWhatsapp,
      });
    }

    if (qtdFacebook > 0) {
      temp.push({
        channel: 4,
        qtd: qtdFacebook,
      });
    }

    if (qtdEmail > 0) {
      temp.push({
        channel: 3,
        qtd: qtdEmail,
      });
    }

    if (qtdWebchat > 0) {
      temp.push({
        channel: 2,
        qtd: qtdWebchat,
      });
    }

    if (qtdVoz > 0) {
      temp.push({
        channel: 1,
        qtd: qtdVoz,
      });
    }

    if (qtdGoogleGBM > 0) {
      temp.push({
        channel: 11,
        qtd: qtdGoogleGBM,
      });
    }

    if (qtdTeams > 0) {
      temp.push({
        channel: 15,
        qtd: qtdTeams,
      });
    }

    if (qtdWhatsappVoice > 0) {
      temp.push({
        channel: 16,
        qtd: qtdWhatsappVoice,
      });
    }

    // temp.push({
    //     channel: 8,
    //     qtd: qtdTelegram
    // })
    // temp.push({
    //     channel: 6,
    //     qtd: qtdInstagram
    // })

    return (
      <PopoverDashboard
        trigger="click"
        boundary="window"
        placement="top"
        multiple={true}
        interactive={true}
        content={renderHandleActions(user)}
      >
        <div className="manager-box-channels">
          {temp.map((todo) => (
            <div className="manager-box-channels__header">
              <div className="manager-box-channels__header-box">
                <span className="manager-box-channels__header-box__legend">
                  {todo.qtd}
                </span>
              </div>
              {renderIcon(todo.channel)}
            </div>
          ))}
        </div>
      </PopoverDashboard>
    );
  };

  const renderQtdCallsMemoized = useCallback(renderQtdCalls, []);

  const renderQtdScreen = (todos, user) => {
    let qtdWhatsapp = 0;
    let qtdFacebook = 0;
    let qtdEmail = 0;
    let qtdWebchat = 0;
    let qtdVoz = 0;
    let qtdTelegram = 0;
    let qtdInstagram = 0;
    let qtdGoogleGBM = 0;
    let qtdTeams = 0;
    let arrayMount = [];

    let aux = todos ? todos.split("¿") : [];
    aux.map((todo) => {
      arrayMount.push({
        CHANNEL: todo.split("§")[0],
        PHONE: todo.split("§")[1],
      });
    });

    arrayMount.map((todo) => {
      if (parseInt(todo.CHANNEL) === 5) qtdWhatsapp = qtdWhatsapp + 1;

      if (parseInt(todo.CHANNEL) === 4) qtdFacebook = qtdFacebook + 1;

      if (parseInt(todo.CHANNEL) === 3) qtdEmail = qtdEmail + 1;

      if (parseInt(todo.CHANNEL) === 2) qtdWebchat = qtdWebchat + 1;

      if (parseInt(todo.CHANNEL) === 1) qtdVoz = qtdVoz + 1;

      if (parseInt(todo.CHANNEL) === 8) qtdTelegram = qtdTelegram + 1;

      if (parseInt(todo.CHANNEL) === 6) qtdInstagram = qtdInstagram + 1;

      if (parseInt(todo.CHANNEL) === 11) qtdGoogleGBM = qtdGoogleGBM + 1;

      if (parseInt(todo.CHANNEL) === 15) qtdTeams = qtdTeams + 1;
    });

    let totalChannel =
      qtdWhatsapp +
      qtdFacebook +
      qtdEmail +
      qtdWebchat +
      // qtdVoz +
      qtdTelegram +
      qtdInstagram +
      qtdGoogleGBM +
      qtdTeams;

    return totalChannel;
  };

  const renderIcon = (media) => {
    if (media === 1) return <VozIcon />;
    if (media === 2) return <WebchatIcon />;
    if (media === 3) return <EmailIcon width="32" height="32" />;
    if (media === 4) return <FacebookIcon />;
    if (media === 5) return <WhatsappIcon />;
    if (media === 6) return <InstaIcon />;
    if (media === 8) return <TelegramIcon />;
    if (media === 11) return <GOOGLEGBM />;
    if (media === 15) return <TEAMS />;
    if (media === 16) return <WhatsappVoiceIcon width="32" height="32" />;
  };

  // function createJson(item) {
  //   if (item) {
  //     let mensagem_tratada = item.replace(/¿/gi, "\n");
  //     mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
  //     let valor = 1;
  //     try {
  //       mensagem_tratada =
  //         '{"' +
  //         valor +
  //         '": [{"mensagem_tratada":"' +
  //         mensagem_tratada +
  //         '"}]}';
  //       let obj = JSON.parse(mensagem_tratada);
  //       mensagem_tratada = obj[1][0].mensagem_tratada;
  //     } catch (e) {
  //       mensagem_tratada = item;
  //     }
  //     return mensagem_tratada;
  //   }
  // }

  const handleModal = (title, user, type) => {
    setInfosGeral({
      title: title,
      type: type,
      ramal: user.ramal,
      agente: user.label,
      grupo: user.desc_grupo,
      iduser: user.iduser,
      user: user,
      jsoncall: user.jsoncall,
    });
    MicroModal.show("modal__seeAtends");
  };

  const closeMonitoring = useCallback(() => {
    setMonitoringInfo("");
    setMonitoringInfoJson("");
  }, []);

  const classifyUserStatus = (user) => {
    if (
      user.status_sip === "LV" &&
      user.status === "AT" &&
      user.status_sip !== "QAT"
    ) {
      return "AT"; // Atendimento
    }
    if (
      (user.status_sip === "AT" && user.status === "AT") ||
      (user.status_sip === "RV" && user.status === "ATOS")
    ) {
      return "AT"; // Atendimento
    }
    if (user.status_sip === "QAT") {
      return "AT"; // Em Consulta
    }
    if (
      (user.status_sip === "AT" && user.status === "ATOS") ||
      (user.status_sip === "ATOS" && user.status === "AT")
    ) {
      return "ATOS"; // Atendimento
    }
    if (user.status_sip === "LV" && user.status === "RV") {
      return "RV";
    }
    if (user.status_sip === "CHND" && user.razao_bloqueio !== "CHND") {
      return "CHND";
    }
    if (user.status_sip === "BQ" && user.razao_bloqueio !== "") {
      return "BQ"; // Pausado
    }
    if (user.status_sip === "ACW" && user.status === "ACW") {
      return "ACW"; // AfterCallWork
    }
    if (
      user.status_sip === null ||
      user.status === null ||
      user.status_sip === "null" ||
      user.status === "null"
    ) {
      return "null"; // Inativo
    }
    if (user.status_sip === "LV" && user.status === "LV") {
      return "LV"; // Livre
    }
    if (user.status_sip === "RV" && user.status === "LV") {
      return "LV"; // Livre
    }
    if (user.status_sip === "BQSUPER" && user.status === "BQSUPER") {
      return "BQSUPER"; // Bloqueado
    }
    return "Inativo"; // Caso não caia em nenhuma regra
  };

  // Função para filtrar os usuários com base nos status desejados
  const filterUsersByStatus = (users, statusFilter) => {
    return users.filter((user) => {
      const userStatus = classifyUserStatus(user);
      return statusFilter.includes(userStatus);
    });
  };

  const filterUsers = (
    users,
    codeStatus,
    FiltersManager,
    groupsPermissionState,
  ) => {
    let newUsers = users;

    newUsers = newUsers.filter((filt) =>
      FiltersManager.filter_manager_group.includes(filt.id_grupo),
    );

    newUsers = filterUsersByStatus(newUsers, codeStatus);

    newUsers = newUsers.filter((filt) =>
      groupsPermissionState.includes(filt.id_grupo),
    );

    // if (searchData) {
    //   newUsers = newUsers.filter(
    //     (filt) =>
    //       filt.desc_grupo.toLowerCase().includes(searchData.toLowerCase()) ||
    //       filt.label.toLowerCase().includes(searchData.toLowerCase())
    //   );
    // }

    return newUsers;
  };

  const filterCodeStatus = () => {
    let newCodeStatus = [];

    let tempIdle = FiltersManager.filter_manager_status.filter(
      (filt) => filt === 1,
    );
    let tempAnswer = FiltersManager.filter_manager_status.filter(
      (filt) => filt === 2,
    );
    let tempReason = FiltersManager.filter_manager_status.filter(
      (filt) => filt === 3,
    );
    let tempBlock = FiltersManager.filter_manager_status.filter(
      (filt) => filt === 4,
    );
    let tempOff = FiltersManager.filter_manager_status.filter(
      (filt) => filt === 5,
    );
    let tempAcw = FiltersManager.filter_manager_status.filter(
      (filt) => filt === 6,
    );

    if (tempIdle.length !== 0) {
      newCodeStatus.push("LV");
    }

    if (tempAnswer.length !== 0) {
      newCodeStatus.push("AT", "ATOS", "RV", "CHND");
    }

    if (tempReason.length !== 0) {
      newCodeStatus.push("BQ");
    }

    if (tempBlock.length !== 0) {
      newCodeStatus.push("BQSUPER");
    }

    if (tempOff.length !== 0) {
      newCodeStatus.push("null");
    }

    if (tempAcw.length !== 0) {
      newCodeStatus.push("ACW");
    }

    return newCodeStatus;
  };

  // const handleStatusExhib = (status) => {
  //   setMakeSearch(true);
  //   setFilterTableStatus((prevStatus) => {
  //     if (status === "Livre") {
  //       return ["LV"];
  //     } else if (status === "Atendimento") {
  //       return ["AT", "ATOS", "RV", "CHND"];
  //     } else {
  //       return ["BQ", "BQSUPER", "null", "ACW"];
  //     }
  //   });
  // };

  // const updateUserInList = useCallback((updatedUser) => {
  //   const userIndex = usersRef.current.findIndex(
  //     (user) =>
  //       user.attendant.config.userId === updatedUser.attendant.config.userId
  //   );

  //   if (userIndex !== -1) {
  //     // Atualiza o usuário apenas se houver mudanças
  //     if (!_.isEqual(usersRef.current[userIndex], updatedUser)) {
  //       const newUsers = [...usersRef.current];
  //       newUsers[userIndex] = {
  //         ...usersRef.current[userIndex],
  //         ...updatedUser,
  //       };

  //       usersRef.current = newUsers;
  //       // return newUsers;
  //     }
  //     // return usersRef.current;
  //   } else {
  //     // Adiciona o novo usuário
  //     const newUsers = [...usersRef.current, updatedUser];
  //     usersRef.current = newUsers;
  //     // return newUsers;
  //   }
  // }, []);

  // const colaboratorsData = useMemo(() => {
  //   return colaboratorsDataFiltered;
  // }, [colaboratorsDataFiltered]);

  const usersDataMap = useMemo(() => {
    const map = new Map();
    managerStatusOperators.forEach((operator) => {
      map.set(operator.idusuario, operator);
    });
    return map;
  }, [managerStatusOperators]);

  function generateUserHash(user) {
    return `${user.iduser}-${user.status}-${user.status_sip}-${user.duration}-${user.ramal}`;
  }

  const processUsersOptimized = useCallback(
    (
      usersReduce,
      FiltersManager,
      managerStatusOperators,
      MonitoringSimult,
      groupsPermissionState,
    ) => {
      const startTime = performance.now();

      // if (startTime - lastProcessTimeRef.current < 100) {
      //   setMakeSearch(false); // Adicione aqui também
      //   return;
      // }
      lastProcessTimeRef.current = startTime;

      setIsProcessing(true);

      requestIdleCallback(
        () => {
          try {
            if (!FiltersManager.is_active) {
              setMakeSearch(false);
              return;
            }

            const codeStatus = filterCodeStatus();
            const groupsPermission = GroupsPermissionSupervisor.map(
              (g) => g.usergroup,
            );

            // Filtragem com status e grupos
            let beforeIsFilter = filterUsers(
              usersReduce,
              codeStatus,
              FiltersManager,
              groupsPermission,
            );

            // IMPORTANTE: Aplica o filtro de busca AQUI
            if (searchData && searchData.trim() !== "") {
              beforeIsFilter = beforeIsFilter.filter(
                (user) =>
                  user.desc_grupo
                    .toLowerCase()
                    .includes(searchData.toLowerCase()) ||
                  user.label.toLowerCase().includes(searchData.toLowerCase()),
              );
            }

            const newData = [];
            const processedIds = new Set();

            for (const user of beforeIsFilter) {
              processedIds.add(user.iduser);

              const cached = processedDataRef.current.get(user.iduser);
              const userHash = generateUserHash(user);

              if (cached && cached.hash === userHash) {
                newData.push(cached.data);
                continue;
              }

              const processed = processUser(
                user,
                usersDataMap,
                renderHandleActions,
                LoginCompleteReducer,
                monitoringInfo,
                setMonitoringInfoJson,
              );

              processedDataRef.current.set(user.iduser, {
                hash: userHash,
                data: processed,
              });

              newData.push(processed);
            }

            // Remove usuários que não estão mais na lista
            for (const [userId] of processedDataRef.current) {
              if (!processedIds.has(userId)) {
                processedDataRef.current.delete(userId);
              }
            }

            setColaboratorsDataFiltered(newData);
            setUsersRefactored(newData);

            console.log(`Processamento: ${performance.now() - startTime}ms`);
          } catch (error) {
            console.error("Erro no processamento:", error);
          } finally {
            setIsProcessing(false);
            setMakeSearch(false); // SEMPRE chama no final
          }
        },
        { timeout: 200 },
      );
    },
    [
      searchData, // Adicione searchData nas dependências
      usersDataMap,
      renderHandleActions,
      LoginCompleteReducer,
      GroupsPermissionSupervisor,
      monitoringInfo,
    ],
  );

  const processRef = useRef(processUsersOptimized);

  const runProcessUsers = useMemo(
    () =>
      throttle(
        (...args) => {
          if (processRef.current) {
            processRef.current(...args);
          }
        },
        2000,
        { leading: true, trailing: true },
      ),
    [],
  );

  // function getCachedPopover(user, renderHandleActions) {
  //   const key = ComponentCache.getKey("popover", user.iduser, user.label);

  //   let component = ComponentCache.get(key);
  //   if (!component) {
  //     component = (
  //       <PopoverDashboard
  //         trigger="click"
  //         boundary="window"
  //         placement="top"
  //         multiple={true}
  //         interactive={true}
  //         content={renderHandleActions(user)}
  //       >
  //         <div style={{ cursor: "pointer" }}>{user.label}</div>
  //       </PopoverDashboard>
  //     );
  //     ComponentCache.set(key, component);
  //   }
  //   return component;
  // }

  // function getCachedTooltip(desc_grupo) {
  //   const key = ComponentCache.getKey("tooltip", desc_grupo);

  //   let component = ComponentCache.get(key);
  //   if (!component) {
  //     component = (
  //       <Tooltippy content={desc_grupo}>
  //         <span className="manager-box-status__text">
  //           {desc_grupo.substr(0, 13)}
  //         </span>
  //       </Tooltippy>
  //     );
  //     ComponentCache.set(key, component);
  //   }
  //   return component;
  // }

  function processUser(
    user,
    usersDataMap,
    renderHandleActions,
    LoginCompleteReducer,
  ) {
    const infosPanel = usersDataMap.get(user.iduser);
    const now = new Date();
    let dataStatusA = now;
    if (user.duration) {
      let getDuration =
        user.duration.split("-")[0].length <= 16
          ? user.duration.split("-")[0] + ":00"
          : user.duration.split("-")[0];
      dataStatusA = parse(getDuration, "dd/MM/yyyy HH:mm:ss", new Date());
    }
    let dataStatusB = null;
    if (user.tmfuturepause && user.tmfuturepause !== "undefined") {
      dataStatusB = parse(
        user.tmfuturepause,
        "dd/MM/yyyy HH:mm:ss",
        new Date(),
      );
    }
    const diferencaSegundos = Math.round(LoginCompleteReducer.difftime || 0);
    const datatimeCompA = addSeconds(now, diferencaSegundos);
    let duracao = Math.max(0, differenceInSeconds(datatimeCompA, dataStatusA));
    let duracaoFPause = dataStatusB
      ? Math.max(0, differenceInSeconds(datatimeCompA, dataStatusB))
      : 0;
    const startDataStatus = subSeconds(new Date(), duracao);
    const startDataPause = subSeconds(new Date(), duracaoFPause);
    const tempoLogadoSeconds =
      infosPanel && parseInt(infosPanel.tempologado)
        ? parseInt(infosPanel.tempologado)
        : 0;
    const startDataLogado = subSeconds(new Date(), tempoLogadoSeconds);
    let exhibTime = "00:00:00";
    let comparator = 0;
    if (infosPanel && infosPanel.maxdigital) {
      const dataFormatoDate = new Date(infosPanel.maxdigital);
      const diferencaEmSegundos = differenceInSeconds(
        new Date(),
        dataFormatoDate,
      );
      if (diferencaEmSegundos >= 0) {
        comparator = diferencaEmSegundos;
        const horas = Math.floor(diferencaEmSegundos / 3600);
        const minutos = Math.floor((diferencaEmSegundos % 3600) / 60);
        const segundos = diferencaEmSegundos % 60;
        exhibTime =
          horas > 24
            ? `${Math.floor(horas / 24)} dia(s), ${String(horas % 24).padStart(
                2,
                "0",
              )}:${String(minutos).padStart(2, "0")}:${String(
                segundos,
              ).padStart(2, "0")}`
            : `${String(horas).padStart(2, "0")}:${String(minutos).padStart(
                2,
                "0",
              )}:${String(segundos).padStart(2, "0")}`;
      }
    }
    const verifyStatus = renderStatusValue(
      user.status,
      user.status_sip,
      user.razao_bloqueio,
      user.descfuturepause,
    );
    // const agentPopover = getCachedPopover(user, renderHandleActions);
    // const groupTooltippy = getCachedTooltip(user.desc_grupo);

    return {
      attendant: {
        data: user,
        config: {
          customOrder: user.label.toLowerCase(),
          userId: user.iduser,
          className: "cell-gray-text",
          filterValue: "",
          textEllipsis: false,
          customData: false,
          favorite: true,
          read: true,
          filter: "",
        },
      },
      ramal: {
        data: user.ramal,
        config: {
          className: "cell-gray-text",
          filterValue: "",
          customOrder: "",
          textEllipsis: false,
          customData: false,
          favorite: true,
          read: true,
          filter: "",
        },
      },
      group: {
        data: user.desc_grupo,
        config: {
          textEllipsis: true,
          className: "cell-blue-text",
          customOrder: user.desc_grupo,
        },
      },
      timelog: {
        data: infosPanel && verifyStatus !== "Inativo" ? startDataLogado : null,
        config: {
          textEllipsis: true,
          customOrder: infosPanel ? infosPanel.tempologado : 0,
          className: `cell-gray-text ${
            infosPanel && verifyStatus !== "Inativo" ? "" : "center-info"
          }`,
        },
      },
      channels: {
        data:
          //user.status === null && user.status_sip === null
          //? ""
          //:
          renderQtdCallsMemoized(
            user.status,
            user.status_sip,
            user.jsoncall,
            user,
          ),
        config: {
          className: "",
        },
      },
      future: {
        data: parseInt(user.futurepause) === 1 ? user.descfuturepause : "",
        config: {
          className: "",
        },
      },
      timepausefuture: {
        data:
          user.tmfuturepause && parseInt(user.futurepause) === 1
            ? startDataPause
            : null,
        config: {
          textEllipsis: true,
          customOrder: user.tmfuturepause ? user.tmfuturepause : 0,
        },
      },
      status: {
        data: renderStatusMemoized(
          user.status,
          user.status_sip,
          user.razao_bloqueio,
          user.descfuturepause,
          user.directionChnd,
        ),
        config: {
          className: "",
          customOrder: renderStatusValue(
            user.status,
            user.status_sip,
            user.razao_bloqueio,
            user.descfuturepause,
            user.directionChnd,
          ),
        },
      },
      timestatus: {
        data: startDataStatus,
        config: {
          textEllipsis: true,
          customOrder: duracao,
        },
      },
      voiceperformed: {
        data: infosPanel ? infosPanel.saidavoz : 0,
        config: {
          className: "",
          cellColor: "blue-cell",
        },
      },
      voiceattend: {
        data: infosPanel ? infosPanel.entvoz : 0,
        config: {
          className: "",
          cellColor: "blue-cell",
        },
      },
      voicetransf: {
        data: infosPanel ? infosPanel.qtdetransfvoz : 0,
        config: {
          className: "",
          cellColor: "blue-cell",
        },
      },
      voicecsat: {
        data: infosPanel
          ? infosPanel.csatvoz
            ? `${infosPanel.csatvoz}%`
            : "-"
          : "-",
        config: {
          className: "",
          cellColor: "blue-cell",
        },
      },
      digitalperformed: {
        data: infosPanel ? infosPanel.saidadigital : 0,
        config: {
          className: "",
          cellColor: "green-cell",
        },
      },
      digitalattend: {
        data: infosPanel ? infosPanel.entdigital : 0,
        config: {
          className: "",
          cellColor: "green-cell",
        },
      },
      digitaltransf: {
        data: infosPanel ? infosPanel.qtdetransfdigital : 0,
        config: {
          className: "",
          cellColor: "green-cell",
        },
      },
      digitalcsat: {
        data: infosPanel
          ? infosPanel.csatdigital
            ? `${infosPanel.csatdigital}%`
            : "-"
          : "-",
        config: {
          className: "",
          cellColor: "green-cell",
        },
      },
      time: {
        data: exhibTime ? exhibTime : "00:00:00",
        config: {
          textEllipsis: true,
          customOrder: new Date(comparator),
        },
      },
      qtdetelas: {
        data:
          renderQtdScreen(user.jsoncall, user) > 0 ? (
            <div
              className="table-see_atends"
              onClick={() => handleModal("Geral", user, 1)}
            >
              {renderQtdScreen(user.jsoncall, user)}
            </div>
          ) : (
            renderQtdScreen(user.jsoncall, user)
          ),

        config: {
          customOrder: renderQtdScreen(user.jsoncall, user),
          textEllipsis: true,
        },
      },
      attendin: {
        data: infosPanel ? (
          renderQtdScreen(user.jsoncall, user) - infosPanel.qtdependente > 0 ? (
            <div
              className="table-see_atends"
              onClick={() => handleModal("Em atendimento", user, 2)}
            >
              {renderQtdScreen(user.jsoncall, user) - infosPanel.qtdependente}
              {/* infosPanel.qtdetelas antigo valor usado */}
            </div>
          ) : (
            0
          )
        ) : (
          0
        ),
        config: {
          customOrder: infosPanel
            ? Math.max(
                0,
                renderQtdScreen(user.jsoncall, user) - infosPanel.qtdependente,
              )
            : 0,
          textEllipsis: true,
        },
      },
      pending: {
        data: infosPanel ? (
          infosPanel.qtdependente > 0 ? (
            <div
              className="table-see_atends"
              onClick={() => handleModal("Pendente", user, 3)}
            >
              {infosPanel.qtdependente}
            </div>
          ) : (
            infosPanel.qtdependente
          )
        ) : (
          0
        ),
        config: {
          customOrder: infosPanel ? infosPanel.qtdependente : 0,
          textEllipsis: true,
        },
      },
      finalized: {
        data: infosPanel ? infosPanel.qtdefinalizadas : 0,
        config: {
          textEllipsis: true,
        },
      },
    };
  }

  useEffect(() => {
    processRef.current = processUsersOptimized;
  }, [processUsersOptimized]);

  useEffect(() => {
    monitoringSimultRef.current = monitoringSim;
  }, [monitoringSim]);

  useEffect(() => {
    monitoringInfoRef.current = monitoringInfo;
  }, [monitoringInfo]);

  useEffect(() => {
    port = localStorage.getItem("port");
    pathname = localStorage.getItem("pathname");
    setMonitoringInfo("");
  }, []);

  useEffect(() => {
    if (dashboardMonitor) {
      MicroModal.show("modal__transferir__chamada");
    }
  }, [dashboardMonitor]);

  useEffect(() => {
    // console.log("VEIO AQ1.7", MonitoringSimult);
    setMonitoringInfo(monitoringInfo);
    setMonitoringSim([...MonitoringSimult]);
  }, [monitoringInfo, MonitoringSimult]);

  useEffect(() => {
    if (GroupsPermissionSupervisor && GroupsPermissionSupervisor.length > 0) {
      setGroupsPermissionState(GroupsPermissionSupervisor);
    }
  }, [GroupsPermissionSupervisor]);

  useEffect(() => {
    rawUsersRef.current = usersReduce;
  }, [usersReduce]);

  useEffect(() => {
    filtersRef.current = {
      FiltersManager,
      managerStatusOperators,
      MonitoringSimult,
      groupsPermissionState,
    };
  }, [
    FiltersManager,
    managerStatusOperators,
    MonitoringSimult,
    groupsPermissionState,
  ]);

  useEffect(() => {
    if (LoginCompleteReducer.isLoginComplete) {
      runProcessUsers(
        rawUsersRef.current,
        filtersRef.current.FiltersManager,
        filtersRef.current.managerStatusOperators,
        filtersRef.current.MonitoringSimult,
        filtersRef.current.groupsPermissionState,
      );
    }
  }, [
    usersReduce,
    FiltersManager,
    managerStatusOperators,
    MonitoringSimult,
    groupsPermissionState,
    LoginCompleteReducer,
    runProcessUsers,
  ]);

  useEffect(() => {
    if (makeSearch) {
      const {
        FiltersManager,
        managerStatusOperators,
        MonitoringSimult,
        groupsPermissionState,
      } = filtersRef.current;

      processUsersOptimized(
        rawUsersRef.current,
        FiltersManager,
        managerStatusOperators,
        MonitoringSimult,
        groupsPermissionState,
      );

      // IMPORTANTE: Reseta o makeSearch após processar
      setMakeSearch(false);
    }
  }, [filterTableStatus, makeSearch, processUsersOptimized]);

  useEffect(() => {
    const searchFoiLimpo =
      searchData === "" && prevSearchDataRef.current !== "";

    if (searchFoiLimpo) {
      const {
        FiltersManager,
        managerStatusOperators,
        MonitoringSimult,
        groupsPermissionState,
      } = filtersRef.current;

      processUsersOptimized(
        rawUsersRef.current,
        FiltersManager,
        managerStatusOperators,
        MonitoringSimult,
        groupsPermissionState,
      );
    }

    prevSearchDataRef.current = searchData;
  }, [searchData, processUsersOptimized]);

  useEffect(() => {
    return () => {
      ComponentCache.clear();
    };
  }, []);

  useEffect(() => {
    return () => {
      runProcessUsers.cancel();
    };
  }, [runProcessUsers]);

  useEffect(() => {
    let timeoutId;
    if (openCard) {
      setShouldRender(true);
    } else {
      timeoutId = setTimeout(() => {
        setShouldRender(false);
      }, 600);
    }
    localStorage.setItem("managerOperatorsOpenCard", openCard);
    return () => clearTimeout(timeoutId);
  }, [openCard]);

  const memoizedTableData = useMemo(() => usersRefactored, [usersRefactored]);
  const memoizedTableColumns = useMemo(
    () => [
      {
        Header: "Atendente",
        accessor: "attendant",
        Hint: "Atendente",
        id: "attendant",
        disableFilters: true,
        sortType: customSorting,
        display: chooseDisplay("Atendente"),
        width: 165,
        typeCell: "popover",
      },
      {
        Header: "Ramal",
        accessor: "ramal",
        Hint: "Ramal",
        id: "ramal",
        disableFilters: true,
        sortType: defaultSorting,
        display: chooseDisplay("Ramal"),
        width: 95,
      },
      {
        Header: "Grupo",
        accessor: "group",
        Hint: "Grupo",
        id: "group",
        sortType: customSorting,
        disableFilters: true,
        display: chooseDisplay("Grupo"),
        width: 135,
        typeCell: "tooltip",
      },
      {
        Header: "Tempo Logado",
        accessor: "timelog",
        Hint: "Tempo Logado",
        id: "timelog",
        disableFilters: true,
        sortType: dateTimeSorting,
        display: chooseDisplay("Tempo Logado"),
        width: 130,
        typeCell: "timer",
      },
      {
        Header: "Canais",
        accessor: "channels",
        Hint: "Canais",
        id: "channels",
        disableFilters: true,
        display: chooseDisplay("Canais"),
        width: 165,
      },
      {
        Header: "Pausa Futura",
        accessor: "future",
        Hint: "Pausa Futura",
        id: "future",
        disableFilters: true,
        sortType: defaultSorting,
        display: chooseDisplay("Pausa Futura"),
        width: 115,
      },
      {
        Header: "Tempo Pausa Futura",
        accessor: "timepausefuture",
        Hint: "Tempo Pausa Futura",
        id: "timepausefuture",
        disableFilters: true,
        sortType: customSorting,
        display: chooseDisplay("Tempo Pausa Futura"),
        width: 165,
        typeCell: "timer",
      },
      {
        Header: "Status",
        accessor: "status",
        Hint: "Status",
        id: "status",
        disableFilters: true,
        sortType: customSorting,
        display: chooseDisplay("Status"),
        width: 175,
      },
      {
        Header: "Tempo do Status",
        accessor: "timestatus",
        Hint: "Tempo do Status",
        id: "timestatus",
        disableFilters: true,
        sortType: dateTimeSorting,
        display: chooseDisplay("Tempo do Status"),
        width: 140,
        typeCell: "timer",
      },
      {
        Header: "Realizadas Voz",
        accessor: "voiceperformed",
        Hint: "Realizadas Voz",
        id: "voiceperformed",
        disableFilters: true,
        sortType: numberSorting,
        display: chooseDisplay("Realizadas Voz"),
        width: 125,
      },
      {
        Header: "Atendidas Voz",
        accessor: "voiceattend",
        Hint: "Atendidas Voz",
        id: "voiceattend",
        disableFilters: true,
        sortType: numberSorting,
        display: chooseDisplay("Atendidas Voz"),
        width: 125,
      },
      {
        Header: "Transf Voz",
        accessor: "voicetransf",
        Hint: "Transferencia Voz",
        id: "voicetransf",
        disableFilters: true,
        sortType: numberSorting,
        display: chooseDisplay("Transf Voz"),
        width: 105,
      },
      {
        Header: "CSAT Voz",
        accessor: "voicecsat",
        Hint: "CSAT Voz",
        id: "voicecsat",
        sortType: numberSorting,
        disableFilters: true,
        display: chooseDisplay("CSAT Voz"),
        width: 105,
      },
      {
        Header: "Realizadas Digital",
        accessor: "digitalperformed",
        Hint: "Realizadas Digital",
        id: "digitalperformed",
        disableFilters: true,
        sortType: numberSorting,
        display: chooseDisplay("Realizadas Digital"),
        width: 125,
      },
      {
        Header: "Atendidas Digital",
        accessor: "digitalattend",
        Hint: "Atendidas Digital",
        id: "digitalattend",
        disableFilters: true,
        sortType: numberSorting,
        display: chooseDisplay("Atendidas Digital"),
        width: 125,
      },
      {
        Header: "Transf Digital",
        accessor: "digitaltransf",
        Hint: "Transferencia Digital",
        id: "digitaltransf",
        disableFilters: true,
        sortType: numberSorting,
        display: chooseDisplay("Transf Digital"),
        width: 125,
      },
      {
        Header: "CSAT Digital",
        accessor: "digitalcsat",
        Hint: "CSAT Digital",
        id: "digitalcsat",
        sortType: numberSorting,
        disableFilters: true,
        display: chooseDisplay("CSAT Digital"),
        width: 125,
      },
      {
        Header: "Tempo",
        accessor: "time",
        Hint: "Tempo",
        id: "time",
        sortType: dateSorting,
        disableFilters: true,
        display: chooseDisplay("Tempo"),
        width: 115,
      },
      {
        Header: "Qtde Telas",
        accessor: "qtdetelas",
        Hint: "Quantidade de Telas",
        id: "qtdetelas",
        sortType: customSorting,
        disableFilters: true,
        display: chooseDisplay("Qtde Telas"),
        width: 105,
      },
      {
        Header: "Em Atendimento",
        accessor: "attendin",
        Hint: "Em Atendimento",
        id: "attendin",
        disableFilters: true,
        sortType: customSorting,
        display: chooseDisplay("Em Atendimento"),
        width: 140,
      },
      {
        Header: "Pendente",
        accessor: "pending",
        Hint: "Pendente",
        id: "pending",
        sortType: customSorting,
        disableFilters: true,
        display: chooseDisplay("Pendente"),
        width: 95,
      },
      {
        Header: "Finalizados",
        accessor: "finalized",
        Hint: "Finalizados",
        id: "finalized",
        disableFilters: true,
        sortType: numberSorting,
        display: chooseDisplay("Finalizados"),
        width: 95,
      },
    ],
    [chooseDisplay],
  );

  let checkSort = localStorage.getItem("sortMarkedOperators")
    ? JSON.parse(localStorage.getItem("sortMarkedOperators"))
    : "";

  // let sortBy = {
  //   sortBy: [],
  // };

  // if (checkSort !== "") {
  //   sortBy = {
  //     sortBy: [
  //       {
  //         id: checkSort ? checkSort.sort : "agent",
  //         desc: checkSort ? checkSort.sortDesc : false,
  //       },
  //     ],
  //   };
  // }
  const sortBy = useMemo(() => {
    if (checkSort !== "") {
      return {
        sortBy: [
          {
            id: checkSort ? checkSort.sort : "agent",
            desc: checkSort ? checkSort.sortDesc : false,
          },
        ],
      };
    }

    return {
      sortBy: [],
    };
  }, [checkSort]);

  return (
    <div
      className={`manager-component__card-table__operators ${
        !openCard ? "close-card" : ""
      }`}
    >
      <div className="manager-component__card-table__box more-space">
        <div
          className="manager-component__card-table__title"
          onClick={() => setOpenCard((open) => !open)}
        >
          <ArrowDown2
            color={openCard ? "#757575" : "#455cc7"}
            style={{ transform: openCard ? "rotate(180deg)" : "rotate(0deg)" }}
          />
          <TextMedium text={title} color={openCard ? "gray" : "blue"} />
        </div>
        {shouldRender && (
          <>
            {connection_platform.exibSearchDash && (
              <InputSearch
                search={searchData}
                setSearch={setSearchData}
                onSearch={(e) => setMakeSearch(true)}
                onKeyDown={true}
              />
            )}
            <PopoverColumnsFilter
              className={"filters-columns"}
              placement="bottom-end"
              menuData={exhibColumn}
              screen="manager_operators"
            >
              <div className="email__container-subheader__actionsTwo">
                <ColumnFilterIcon />
                <span className="email__container-subheader__actionsTwo-span">
                  Colunas
                </span>
              </div>
            </PopoverColumnsFilter>
          </>
        )}
      </div>
      {shouldRender && (
        <div className="manager-component__card-table__area operators-manager">
          {makeSearch && (
            <div className="loading-overblock">
              <Loading.Dots />
            </div>
          )}
          {LoginCompleteReducer.isLoginComplete ? (
            memoizedTableData.length !== 0 ? (
              <TableVirtual
                key={"table-virtual-operators"}
                className="table-operatorsManagers"
                data={memoizedTableData}
                columns={memoizedTableColumns}
                fixedHeader
                renderHandleActions={renderHandleActions}
                initialState={sortBy}
                screen="manager_operators"
                rowShadowLine
              />
            ) : (
              // <Table
              //   key={JSON.stringify(
              //     colaboratorsDataFiltered.map((user) => user.iduser)
              //   )}
              //   className="table-operatorsManagers"
              //   data={memoizedTableData}
              //   columns={memoizedTableColumns}
              //   fixedHeader
              //   // fixedFirstColumn
              //   // filtersActive={filtersActive}
              //   // emptyState={emptyState}
              //   // setEmptyState={setEmptyState}
              //   initialState={sortBy}
              //   screen="manager_operators"
              //   rowShadowLine
              // />
              <div className="manager-component__card-table__area-empty">
                <EmptyState />
              </div>
            )
          ) : (
            <img src={LoadingTable} alt="loading" />
          )}
        </div>
      )}
      <BlockUnBlockUserModal
        duration={duration}
        userout={userout}
        reasonaction={reasonaction}
        horaaction={horaaction}
        act={act}
        actdesb={actdesb}
        setActDesb={setActDesb}
        inable={inable}
        setAct={setAct}
        idblock={idblock}
        idsup={idsup}
      />
      <SeeAtends
        infos={infosGeral}
        setInfos={setInfosGeral}
        setActionsBlock={{
          setReasonAction,
          setDuration,
          setHoraAction,
          setAct,
          setActDesb,
          setInable,
          setUserOut,
          setIdSup,
          setIdBlock,
        }}
        setInfoTransfer={setInfoTransfer}
        infoTransfer={infoTransfer}
        setMonitorDash={setDashboardMonitor}
        editTypeMonitoring={editTypeMonitoring}
        reduxMonitoringInitial={reduxMonitoringInitial}
      />
      {/* <TransferClient infoQueue={infoQueue} /> */}
      {dashboardMonitor && (
        <TransferClientModal
          dashboardMonitor={dashboardMonitor}
          setInfoTransfer={setInfoTransfer}
          setMonitorDash={setDashboardMonitor}
        />
      )}
      {monitoringInfo && (
        <MonitoringDashboardV2
          attendant={monitoringInfo}
          infoJson={monitoringInfoJson}
          onClose={closeMonitoring}
        />
      )}
    </div>
  );
};

export default React.memo(CardTableOperatorsManager);
